
import { withParams } from 'vuelidate';

export default withParams(
    {
        type: 'phone',
        message: 'Geben Sie eine gültige Telefonnummer ein.',
    },
    (value) => {
        if (!value) {
            return true;
        }

        // Current no validation for phone number
        return true;
    },
);
